module.exports = __webpack_public_path__ + "img/52002751_S.65784c57.png";